import React, { Component } from 'react';

//MUI Components
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

function FamilyDetails({
	fatherName,
	fatherNumber,
	motherName,
	motherNumber,
	handleChange,
	data,
}) {
	return (
		<div>
			<center>
				<h3 className='profile-header'>
					<Typography variant='h6' gutterBottom>
						Family Details
					</Typography>
				</h3>
			</center>
			<Grid container spacing={3}>
				<Grid item xs={12} sm={6}>
					<TextField
						variant='standard'
						label='Father Name'
						error={data['fatherName'].error}
						helperText={
							data['fatherName'].error
								? data['fatherName'].helperText
								: ''
						}
						fullWidth
						required
						name='fatherName'
						value={fatherName}
						placeholder="Enter your father's name"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						variant='standard'
						label='Father Number'
						error={data['fatherNumber'].error}
						helperText={
							data['fatherNumber'].error
								? data['fatherNumber'].helperText
								: ''
						}
						fullWidth
						required
						name='fatherNumber'
						value={fatherNumber}
						placeholder="Enter your father's number"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						variant='standard'
						label='Mother Name'
						error={data['motherName'].error}
						helperText={
							data['motherName'].error
								? data['motherName'].helperText
								: ''
						}
						fullWidth
						required
						name='motherName'
						value={motherName}
						placeholder="Enter your mother's name"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						variant='standard'
						label='Mother Number'
						error={data['motherNumber'].error}
						helperText={
							data['motherNumber'].error
								? data['motherNumber'].helperText
								: ''
						}
						fullWidth
						required
						name='motherNumber'
						value={motherNumber}
						placeholder="Enter your mother's number"
						onChange={handleChange}
					/>
				</Grid>
			</Grid>
		</div>
	);
}

export default FamilyDetails;
